import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("input", {
  name: "username",
  type: "text",
  class: "w-full rounded-md"
}, null, -1)
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  name: "current_role",
  type: "text",
  class: "w-full rounded-md"
}, null, -1)
const _hoisted_6 = { class: "py-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("input", {
  name: "new_role",
  type: "text",
  class: "w-full rounded-md"
}, null, -1)
const _hoisted_8 = { class: "py-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("textarea", {
  class: "w-full h-20 rounded-md",
  name: "remark"
}, null, -1)

import ToolsUpload from '../../tools/Upload.vue';
import ExampleTicketToolTip from './tooltip/ExampleTicketTooltip.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateChangeRoleAdmin',
  props: {
  username: String
},
  setup(__props) {


const getExampleImage = () =>{
  const baseUrl = window.location.origin
  return `${baseUrl}/ticket-example/รูปตัวอย่าง ขอเปลี่ยนแปลงตำแหน่งงานยูเซอร์แอดมิน.png`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.username')) + " ", 1),
        _createVNode(ExampleTicketToolTip, {
          image: getExampleImage()
        }, null, 8, ["image"])
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.currentRole')) + " ", 1),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.newRole')) + " ", 1),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.remark')) + " ", 1),
      _hoisted_9
    ]),
    _createVNode(ToolsUpload)
  ], 64))
}
}

})